import { Routes } from '@angular/router';
import { MainLayoutComponent } from './Layout/main-layout/main-layout.component';
import { MainLayout2Component } from './Layout/main-layout2/main-layout2.component';
import { MainLayout3Component } from './Layout/main-layout3/main-layout3.component';
import { MainLayout4Component } from './Layout/main-layout4/main-layout4.component';
import { TestComponent } from './Test/test/test.component';
import { LoginComponent } from './Login/login/login.component';
import { AuthGuardService } from './Util/AuthGuard/auth-guard.service';
import { ShiftComponent } from './Master/Shift/shift/shift.component';
import { ShiftFormComponent } from './Master/Shift/shift-form/shift-form.component';
import { RegisterComponent } from './Register/register/register.component';
import { RegisterInitFormComponent } from './Register/register-init-form/register-init-form.component';
import { RegisterFormComponent } from './Register/register-form/register-form.component';
import { ApprovalMatrixFormComponent } from './Setting/ApprovalMatrix/approval-matrix-form/approval-matrix-form.component';
import { ApprovalMatrixComponent } from './Setting/ApprovalMatrix/approval-matrix/approval-matrix.component';
import { AttendancePoliciesComponent } from './Setting/AttendancePolicies/attendance-policies/attendance-policies.component';
import { AttendancePoliciesFormComponent } from './Setting/AttendancePolicies/attendance-policies-form/attendance-policies-form.component';
import { RegularizationPoliciesComponent } from './Setting/RegularizationPolicies/regularization-policies/regularization-policies.component';
import { RegularizationPoliciesFormComponent } from './Setting/RegularizationPolicies/regularization-policies-form/regularization-policies-form.component';
import { WeekOffPoliciesComponent } from './Setting/WeekOffPolicies/week-off-policies/week-off-policies.component';
import { WeekOffPoliciesFormComponent } from './Setting/WeekOffPolicies/week-off-policies-form/week-off-policies-form.component';
import { ShiftPoliciesComponent } from './Setting/ShiftPolicies/shift-policies/shift-policies.component';
import { ShiftPoliciesFormComponent } from './Setting/ShiftPolicies/shift-policies-form/shift-policies-form.component';
import { LeaveHistoryComponent } from './Request/Leave/leave-history/leave-history.component';
import { LeaveRequestFormComponent } from './Request/Leave/leave-request-form/leave-request-form.component';
import { AttendanceComponent } from './Request/Attendance/attendance/attendance.component';
import { LeaveApprovalComponent } from './ToDo/LeaveApproval/leave-approval/leave-approval.component';
import { RegularizationApprovalComponent } from './ToDo/RegularizationApproval/regularization-approval/regularization-approval.component';
import { AttendanceApprovalComponent } from './ToDo/AttendanceApproval/attendance-approval/attendance-approval.component';
import { DashboardComponent } from './Dashboard/dashboard/dashboard.component';
import { HolidayComponent } from './Master/Holiday/holiday/holiday.component';
import { CompanyHolidayComponent } from './Master/CompanyHoliday/company-holiday/company-holiday.component';
import { StateHolidayComponent } from './Master/StateHoliday/state-holiday/state-holiday.component';
import { ClientHolidayComponent } from './Master/ClientHoliday/client-holiday/client-holiday.component';
import { SiteHolidayComponent } from './Master/SiteHoliday/site-holiday/site-holiday.component';
import { CompanyPolicyTypeComponent } from './Master/CompanyPolicyType/company-policy-type/company-policy-type.component';
import { TATComponent } from './Master/TAT/tat/tat.component';
import { RoleComponent } from './Master/Role/role/role.component';

import { HomeComponent } from './Home/home/home.component';
import { ClientHolidayFormComponent } from './Master/ClientHoliday/client-holiday-form/client-holiday-form.component';
import { SiteHolidayFormComponent } from './Master/SiteHoliday/site-holiday-form/site-holiday-form.component';
import { StateHolidayFormComponent } from './Master/StateHoliday/state-holiday-form/state-holiday-form.component';
import { RegularizationFormComponent } from './Request/regularization/regularization-form/regularization-form.component';
import { RegularizationComponent } from './Request/regularization/Regularization/regularization.component';
import { CalendarComponent } from './Calendar/calendar/calendar.component';
import { RegisterDetailComponent } from './Register/register-detail/register-detail.component';
import { RegisterPreonbordingSetupComponent } from './Register/register-preonbording-setup/register-preonbording-setup.component';
import { PreOnboardinMainLayouComponent } from './Layout/pre-onboardin-main-layou/pre-onboardin-main-layou.component';
import { ClientGroupMasterComponent } from './ClientGroupMaster/client-group-master/client-group-master.component';
import { ClientGroupViewComponent } from './ClientGroupMaster/client-group-view/client-group-view.component';
import { AdditionOfManpowerComponent } from './LocationMaster/addition-of-manpower/addition-of-manpower.component';
import { BranchGeoMappingComponent } from './LocationMaster/branch-geo-mapping/branch-geo-mapping.component';
import { GeoMappingComponent } from './LocationMaster/geo-mapping/geo-mapping.component';
import { LocationMasterComponent } from './LocationMaster/location-master/location-master.component';
import { LocationViewComponent } from './LocationMaster/location-view/location-view.component';
import { ManpowerAlterationFormComponent } from './LocationMaster/manpower-alteration-form/manpower-alteration-form.component';
import { ReductionOfManpowerComponent } from './LocationMaster/reduction-of-manpower/reduction-of-manpower.component';
import { SiteGeoMappingComponent } from './LocationMaster/site-geo-mapping/site-geo-mapping.component';
import { BranchHolidayFormComponent } from './Master/BranchHoliday/branch-holiday-form/branch-holiday-form.component';
import { BranchHolidayComponent } from './Master/BranchHoliday/branch-holiday/branch-holiday.component';
import { AllMastersComponent } from './OneFeildMasters/all-masters/all-masters.component';
import { LeavePoliciesFormComponent } from './Setting/LeavePolicies/leave-policies-form/leave-policies-form.component';
import { LeavePoliciesComponent } from './Setting/LeavePolicies/leave-policies/leave-policies.component';
import { FeedComponent } from './Feeds/feed/feed.component';
import { FeedListComponent } from './Feeds/feed-list/feed-list.component';
import { AssetGroupMasterComponent } from './AssetModule/asset-group-master/asset-group-master.component';
import { AssetGroupMasterFormComponent } from './AssetModule/asset-group-master-form/asset-group-master-form.component';
import { MultipleLocationGeoMappingComponent } from './LocationMaster/multiple-location-geo-mapping/multiple-location-geo-mapping.component';

import { ViewOfAllocateManpowerComponent } from './LocationMaster/view-of-allocate-manpower/view-of-allocate-manpower.component';

import { NotificationComponent } from './Notification/notification/notification.component';
import { LeaveApprovalDetailComponent } from './ToDo/LeaveApproval/leave-approval-detail/leave-approval-detail.component';
import { RegularizationApprovalDetailComponent } from './ToDo/RegularizationApproval/regularization-approval-detail/regularization-approval-detail.component';
import { AttendanceApprovalDetailComponent } from './ToDo/AttendanceApproval/attendance-approval-detail/attendance-approval-detail.component';
import { AssetMasterComponent } from './AssetModule/asset-master/asset-master.component';
import { AssetMasterFormComponent } from './AssetModule/asset-master-form/asset-master-form.component';
import { HolidayListOnIDComponent } from './Master/holiday-list-on-id/holiday-list-on-id.component';
import { LeavFormComponent } from './Master/LeaveMaster/leav-form/leav-form.component';
import { LeaveViewComponent } from './Master/LeaveMaster/leave-view/leave-view.component';
import { AttendenceResetComponent } from './Setting/AttendenceReset/attendence-reset/attendence-reset.component';
import { DeviceResetComponent } from './Setting/ResetDevice/device-reset/device-reset.component';
import { EmployeeLeaveManagementComponent } from './Setting/EmployeeLeaveManagement/employee-leave-management/employee-leave-management.component';
import { AssetAdditionComponent } from './AssetModule/asset-addition/asset-addition.component';
import { AssetAdditionFormComponent } from './AssetModule/asset-addition-form/asset-addition-form.component';
import { AssetAdditionalDetailComponent } from './AssetModule/asset-additional-detail/asset-additional-detail.component';
import { AssetTransferComponent } from './AssetModule/AssetTransfer/asset-transfer/asset-transfer.component';
import { AssetTransferFormComponent } from './AssetModule/AssetTransfer/asset-transfer-form/asset-transfer-form.component';
import { AssetAllotmentComponent } from './AssetModule/AssetAllotment/asset-allotment/asset-allotment.component';
import { AssetAllotmentFormComponent } from './AssetModule/AssetAllotment/asset-allotment-form/asset-allotment-form.component';
import { LoginInitiationComponent } from './Setting/LoginInitation/login-initiation/login-initiation.component';
import { UserRightComponent } from './Setting/UserRight/user-right/user-right.component';
import { DashboardBackComponent } from './Dashboard/dashboard-back/dashboard-back.component';
import { RegistrationApprovalComponent } from './ToDo/RegistrationApproval/registration-approval/registration-approval.component';
import { RegistrationApprovalDetailComponent } from './ToDo/RegistrationApproval/registration-approval-detail/registration-approval-detail.component';

import { BranchHeadComponent } from './Setting/ReportingTo/branch-head/branch-head.component';
import { ClientHeadComponent } from './Setting/ReportingTo/client-head/client-head.component';
import { CompanyHeadComponent } from './Setting/ReportingTo/company-head/company-head.component';
import { SiteHeadComponent } from './Setting/ReportingTo/site-head/site-head.component';
import { EmployeeToComponent } from './Setting/ReportingTo/employee-to/employee-to.component';
import { MobileRegisterComponent } from './Register/mobile-register/mobile-register.component';
import { IMEISearchComponent } from './Setting/imeisearch/imeisearch.component';
import { CompanyEmployeeDetailsComponent } from './Register/company-employee-details/company-employee-details.component';
import { ForceCheckOutUtilityComponent } from './Setting/force-check-out-utility/force-check-out-utility.component';
import { PreOnboardingComponent } from './Register/PreOnboarding/pre-onboarding/pre-onboarding.component';
import { CandidateInitiationComponent } from './Register/CandidateInitiation/candidate-initiation/candidate-initiation.component';
import { FroceCheckOutUtilityLogReportsComponent } from './Reports/froce-check-out-utility-log-reports/froce-check-out-utility-log-reports.component';
import { CompensatoryOffFormComponent } from './Request/CompensatoryOff/compensatory-off-form/compensatory-off-form.component';
import { CompensatoryOffComponent } from './Request/CompensatoryOff/compensatory-off/compensatory-off.component';
import { CompensatoryOffPolicyFormComponent } from './Setting/CompensatoryOffPolicy/compensatory-off-policy-form/compensatory-off-policy-form.component';
import { CompensatoryOffPolicyComponent } from './Setting/CompensatoryOffPolicy/compensatory-off-policy/compensatory-off-policy.component';
import { EmployeeLeaveManagementBackComponent } from './Setting/employee-leave-management-back/employee-leave-management-back.component';
import { FrontReportComponent } from './Reports/FrontReport/front-report/front-report.component';
import { BackReportComponent } from './Reports/BackReport/back-report/back-report.component';
import { MonthlyAttendenceDetailsEmpwiseLogComponent } from './Reports/monthly-attendence-details-empwise-log/monthly-attendence-details-empwise-log.component';
import { MonthlyAttendenceDetailsEmpFrontLogComponent } from './Reports/monthly-attendence-details-emp-front-log/monthly-attendence-details-emp-front-log.component';
import { MonthlyAttendenceDetailsEmpBackLogComponent } from './Reports/monthly-attendence-details-emp-back-log/monthly-attendence-details-emp-back-log.component';
import { LeaveDetailEmpwiseLogComponent } from './Reports/leave-detail-empwise-log/leave-detail-empwise-log.component';
import { LeaveDetailFrontLogComponent } from './Reports/leave-detail-front-log/leave-detail-front-log.component';
import { LeaveDetailBackLogComponent } from './Reports/leave-detail-back-log/leave-detail-back-log.component';
import { RegularizeEmpwiseLogComponent } from './Reports/regularize-empwise-log/regularize-empwise-log.component';
import { RegularizeFrontLogComponent } from './Reports/regularize-front-log/regularize-front-log.component';
import { RegularizeBackLogComponent } from './Reports/regularize-back-log/regularize-back-log.component';
import { InstalledEmpFrontComponent } from './Reports/installed-emp-front/installed-emp-front.component';
import { InstalledEmpBackComponent } from './Reports/installed-emp-back/installed-emp-back.component';
import { OtherDutyDetailFrontComponent } from './Reports/other-duty-detail-front/other-duty-detail-front.component';
import { OtherDutyDetailBackComponent } from './Reports/other-duty-detail-back/other-duty-detail-back.component';
import { EmployeeReportComponent } from './Reports/EmployeeReport/employee-report/employee-report.component';
import { ExpenseComponent } from './Request/Expense/expense/expense.component';
import { ExpenseFormComponent } from './Request/Expense/expense-form/expense-form.component';
import { OptionalHolidayFormComponent } from './Request/OptionalHoliday/optional-holiday-form/optional-holiday-form.component';
import { OptionalHolidayComponent } from './Request/OptionalHoliday/optional-holiday/optional-holiday.component';
import { ExpensePolicyComponent } from './Setting/ExpensePolicy/expense-policy/expense-policy.component';
import { ExpensePolicyFormComponent } from './Setting/ExpensePolicy/expense-policy-form/expense-policy-form.component';
import { SiteWiseManpowerSummaryComponent } from './LocationMaster/site-wise-manpower-summary/site-wise-manpower-summary.component';
import { SiteWiseManpowerSummaryNewComponent } from './LocationMaster/SiteWiseManpowerSummaryNew/site-wise-manpower-summary-new/site-wise-manpower-summary-new.component';
import { AdditionOfManpowerNewComponent } from './LocationMaster/AdditionOfManpowerNew/addition-of-manpower-new/addition-of-manpower-new.component';
import { ReductionOfManpowerNewComponent } from './LocationMaster/ReductionOfManpowerNew/reduction-of-manpower-new/reduction-of-manpower-new.component';
import { ViewOfAllocateManpowerNewComponent } from './LocationMaster/ViewOfAllocateManpowerNew/view-of-allocate-manpower-new/view-of-allocate-manpower-new.component';
import { OptionalHolidayPolicyFormComponent } from './Setting/OptionalHolidayPolicy/optional-holiday-policy-form/optional-holiday-policy-form.component';
import { OptionalHolidayPolicyComponent } from './Setting/OptionalHolidayPolicy/optional-holiday-policy/optional-holiday-policy.component';
import { OptionalHolidayApprovalComponent } from './ToDo/OptionalHolidayApproval/optional-holiday-approval/optional-holiday-approval.component';
import { OptionalHolidayApprovalDetailComponent } from './ToDo/OptionalHolidayApproval/optional-holiday-approval-detail/optional-holiday-approval-detail.component';
import { OptionalHolidayReportFrontComponent } from './Reports/OptionalHolidayReportFront/optional-holiday-report-front/optional-holiday-report-front.component';
import { OptionalHolidayReportBackComponent } from './Reports/OptionalHolidayReportBack/optional-holiday-report-back/optional-holiday-report-back.component';
import { OptionalHolidayReportEmpWiseComponent } from './Reports/OptionalHolidayReportEmpWise/optional-holiday-report-emp-wise/optional-holiday-report-emp-wise.component';
import { RegularizationApprovalEmpComponent } from './Request/regularization/regularization-approval-emp/regularization-approval-emp.component';
import { LeaveApprovalEmpComponents } from './Request/Leave/leave-approval-emp/leave-approval-emp.component';
import { CompensatoryOffConsumeComponent } from './Request/CompensatoryOffConsume/compensatory-off-consume/compensatory-off-consume.component';
import { CompensatoryOffConsumeFormComponent } from './Request/CompensatoryOffConsume/compensatory-off-consume-form/compensatory-off-consume-form.component';
import { CompensatoryOffApprovalComponent } from './ToDo/CompensatoryOffApproval/compensatory-off-approval/compensatory-off-approval.component';
import { CompensatoryOffApprovalDetailComponent } from './ToDo/CompensatoryOffApproval/compensatory-off-approval-detail/compensatory-off-approval-detail.component';
import { CompensatoryOffConsumeApprovalComponent } from './ToDo/CompensatoryOffConsumApproval/compensatory-off-consume-approval/compensatory-off-consume-approval.component';
import { CompensatoryOffConsumeApprovalDetailComponent } from './ToDo/CompensatoryOffConsumApproval/compensatory-off-consume-approval-detail/compensatory-off-consume-approval-detail.component';
import { DuplicateDevicePunchingDetailsBackComponent } from './Reports/DuplicateDevicePunchingDetailsBack/duplicate-device-punching-details-back/duplicate-device-punching-details-back.component';
import { DuplicateDevicePunchingDetailsFrontComponent } from './Reports/DuplicateDevicePunchingDetailsFront/duplicate-device-punching-details-front/duplicate-device-punching-details-front.component';
import { CommonReportComponent } from './Reports/CommonReport/common-report/common-report.component';
import { SupportTicketComponent } from './Support/support-ticket/support-ticket.component';
import { SiteUserRightsComponent } from './Master/site-user-rights/site-user-rights.component';
import { ShiftRosterComponent } from './Setting/ShiftRoster/shift-roster/shift-roster.component';
import { ExpenseCategoryComponent } from './Expense/ExpenseCategory/expense-category/expense-category.component';
import { VehicleComponent } from './Expense/Vehicle/vehicle/vehicle.component';
import { LocationMasterNewComponent } from './LocationMaster/location-master-new/location-master-new.component';
import { ReimbursementFormComponent } from './Request/Reimbursement/reimbursement-form/reimbursement-form.component';
import { ReimbursementApprovalComponent } from './ToDo/ReimbursementApproval/reimbursement-approval/reimbursement-approval.component';
import { ReimbursementApprovalDetailComponent } from './ToDo/ReimbursementApproval/reimbursement-approval-detail/reimbursement-approval-detail.component';
import { ReimbursementLoadComponent } from './Request/Reimbursement/reimbursement-load/reimbursement-load.component';
import { QusetionnarieFormComponent } from './EmpConfirmation/qusetionnarie-form/qusetionnarie-form.component';
import { ExpenseReimbursementComponent } from './Expense/ExpenseReimbursement/expense-reimbursement/expense-reimbursement.component';
import { TemplateViewComponent } from './Master/TemplateModule/template-view/template-view.component';
import { AdvanceExpenseComponent } from './Request/Expense/advance-expense/advance-expense.component';
import { ExpenseTripComponent } from './Request/Expense/expense-trip/expense-trip.component';
import { OutstationComponent } from './Request/Expense/outstation/outstation.component';
import { AdvanceExpenseApprovalComponent } from './ToDo/Expense/advance-expense-approval/advance-expense-approval.component';
import { AdvanceExpenseApprovalDetailComponent } from './ToDo/Expense/advance-expense-approval-detail/advance-expense-approval-detail.component';
import { ExpenseApprovalComponent } from './ToDo/Expense/expense-approval/expense-approval.component';
import { ExpenseApprovalDetailComponent } from './ToDo/Expense/expense-approval-detail/expense-approval-detail.component';
import { ForceMobileVerificationComponent } from './Setting/force-mobile-verification/force-mobile-verification.component';
import { EmployeeConfirmationPoliciesComponent } from './Setting/EmployeeConfirmationPolicies/employee-confirmation-policies/employee-confirmation-policies.component';
import { ExpenseHistoryComponent } from './Expense/ExpenseHistory/expense-history/expense-history.component';
import { EFSRFileDownloadComponent } from './Reports/efsrfile-download/efsrfile-download.component';
import { EmployeeConfirmationPoliciesFormComponent } from './Setting/EmployeeConfirmationPolicies/employee-confirmation-policies-form/employee-confirmation-policies-form.component';
import { ConfirmationEmpDetailsComponent } from './EmpConfirmation/confirmation-emp-details/confirmation-emp-details.component';
import { QuestionnaireComponent } from './EmpConfirmation/questionnaire/questionnaire.component';
import { EmpConfirmationComponent } from './Request/EmpConfirmation/emp-confirmation/emp-confirmation.component';
import { SiteUserComponent } from './Master/SiteUser/site-user/site-user.component';
import { EmpConfirmationDetailComponent } from './Request/EmpConfirmation/emp-confirmation-detail/emp-confirmation-detail.component';
import { EmpConfirmationApprovalComponent } from './ToDo/EmpConfirmationApproval/emp-confirmation-approval/emp-confirmation-approval.component';
import { EmpConfirmationApprovalDetailComponent } from './ToDo/EmpConfirmationApproval/emp-confirmation-approval-detail/emp-confirmation-approval-detail.component';
import { LTAPolicyComponent } from './Setting/LTAPolicy/ltapolicy/ltapolicy.component';
import { LTAPolicyFormComponent } from './Setting/LTAPolicy/ltapolicy-form/ltapolicy-form.component';
import { CompanyDocumentComponent } from './CompanyDocument/company-document/company-document.component';
import { CompanyPolicyMasterComponent } from './CompanyDocument/company-policy-master/company-policy-master.component';
import { CompanyHolidayFormComponent } from './Master/CompanyHoliday/company-holiday-form/company-holiday-form.component';
import { CompanyPolicyMasterFormComponent } from './CompanyDocument/company-policy-master-form/company-policy-master-form.component';
import { LetterDocumentTypeComponent } from './Letter/LetterDocumentType/letter-document-type/letter-document-type.component';
import { LetterTemplateComponent } from './Letter/LetterTemplate/letter-template/letter-template.component';
import { LetterTemplateUploadComponent } from './Letter/LetterTemplateUpload/letter-template-upload/letter-template-upload.component';
import { LetterGenerateComponent } from './Letter/LetterGenerate/letter-generate/letter-generate.component';
import { LetterGenerateFormComponent } from './Letter/LetterGenerate/letter-generate-form/letter-generate-form.component';
import { EmployeeLetterComponent } from './Letter/EmployeeLetter/employee-letter/employee-letter.component';
import { ShiftGroupComponent } from './Master/ShiftGroup/shift-group/shift-group.component';
import { LetterApprovalDetailComponent } from './ToDo/LetterApproval/letter-approval-detail/letter-approval-detail.component';
import { LetterApprovalComponent } from './ToDo/LetterApproval/letter-approval/letter-approval.component';
import { ViewSupportProfileComponent } from './Support/view-support-profile/view-support-profile.component';
import { IDCardFrontReportComponent } from './Register/ReportMaster/idcard-front-report/idcard-front-report.component';
import { EmpProfileDetailsUpdateComponent } from './ToDo/EmployeeDetails/ProfileDetails/emp-profile-details-update/emp-profile-details-update.component';
import { ProfileDetailsRequestComponent } from './Request/EmployeeDetails/profile-details-request/profile-details-request.component';
import { ProfileRequestDetailComponent } from './ToDo/EmployeeDetails/ProfileDetails/profile-request-detail/profile-request-detail.component';
import { TicketAssignComponent } from './Support/ticket-assign/ticket-assign.component';
import { LocalReimbursementComponent } from './Expense/local-reimbursement/local-reimbursement.component';
import { EmpConfirmationBulkComponent } from './EmpConfirmation/emp-confirmation-bulk/emp-confirmation-bulk.component';
import { ClaimedReimbursementComponent } from './Reimbursement/claimed-reimbursement/claimed-reimbursement.component';
import { PayReimbursementComponent } from './Reimbursement/pay-reimbursement/pay-reimbursement.component';
import { ClusterComponent } from './Master/Cluster/cluster/cluster.component';
import { ClusterFormComponent } from './Master/Cluster/cluster-form/cluster-form.component';
import { RouteComponent } from './Master/Route/route/route.component';
import { RouteFormComponent } from './Master/Route/route-form/route-form.component';
import { SeperateFormComponent } from './Seperation/seperate-form/seperate-form.component';
import { ReasonComponent } from './Master/Reason/reason/reason.component';
import { SeperationPoliciesComponent } from './Setting/SeperationPolicies/seperation-policies/seperation-policies.component';
import { SeperationPoliciesFormComponent } from './Setting/SeperationPolicies/seperation-policies-form/seperation-policies-form.component';
import { UploadDocFormComponent } from './Master/UploadDocument/upload-doc-form/upload-doc-form.component';
import { DailyAttendanceComponent } from './WebAttendance/daily-attendance/daily-attendance.component';
import { HelpDeskReportsComponent } from './Support/help-desk-reports/help-desk-reports.component';
import { SiteTypeComponent } from './Master/SiteTypeMaster/site-type/site-type.component';
import { WebMonthAttendanceComponent } from './WebMonthAttendance/web-month-attendance/web-month-attendance.component';
import { TaxCategoryComponent } from './IncomeTax/TaxCategory/tax-category/tax-category.component';
import { TaxCategorySlabComponent } from './IncomeTax/TaxCategorySlab/tax-category-slab/tax-category-slab.component';
import { TaxSectionComponent } from './IncomeTax/TaxSection/tax-section/tax-section.component';
import { TaxSubSectionComponent } from './IncomeTax/TaxSubSection/tax-sub-section/tax-sub-section.component';
import { ModuleLayoutComponent } from './Layout/module-layout/module-layout.component';
import { ModulesListComponent } from './Modules/modules-list/modules-list.component';
import { ApprovalDetailsComponent } from './Register/ReportMaster/approval-details/approval-details.component';
import { OutOfOfficeComponent } from './Setting/OutOfOffice/out-of-office/out-of-office.component';
import { OutOfOfficeFormComponent } from './Setting/OutOfOffice/out-of-office-form/out-of-office-form.component';
import { TaxDeclarationFormComponent } from './IncomeTax/TaxDeclaration/tax-declaration-form/tax-declaration-form.component';
import { TaxDeclarationComponent } from './IncomeTax/TaxDeclaration/tax-declaration/tax-declaration.component';
import { FormOutOfOfficeComponent } from './Request/OutOfOffice/form-out-of-office/form-out-of-office.component';
import { OutOfOfficeLoadComponent } from './Request/OutOfOffice/out-of-office-load/out-of-office-load.component';
import { OutOfOfficeApprovalDetailComponent } from './ToDo/OutOfOffice/out-of-office-approval-detail/out-of-office-approval-detail.component';
import { OutOfOfficeApprovalComponent } from './ToDo/OutOfOffice/out-of-office-approval/out-of-office-approval.component';
import { TaxDeclarationDetailComponent } from './IncomeTax/TaxDeclaration/tax-declaration-detail/tax-declaration-detail.component';
import { TaxDeclarationPreviewComponent } from './IncomeTax/TaxDeclaration/tax-declaration-preview/tax-declaration-preview.component';
import { TaxDeclarationCompareComponent } from './IncomeTax/TaxDeclaration/tax-declaration-compare/tax-declaration-compare.component';
import { EmpAttendanceMergeComponent } from './Register/ReportMaster/emp-attendance-merge/emp-attendance-merge.component';
import { TaxDeclarationApprovalDetailComponent } from './ToDo/TaxDeclarationApproval/tax-declaration-approval-detail/tax-declaration-approval-detail.component';
import { TaxDeclarationApprovalComponent } from './ToDo/TaxDeclarationApproval/tax-declaration-approval/tax-declaration-approval.component';
import { TaxInvestmentComponent } from './IncomeTax/TaxInvestment/tax-investment/tax-investment.component';
import { TaxInvestmentFormComponent } from './IncomeTax/TaxInvestment/tax-investment-form/tax-investment-form.component';
import { AttendanceEmpComponent } from './EmployeeAttendance/attendance-emp/attendance-emp.component';
import { EmpSearchComponent } from './EmployeeSearch/emp-search/emp-search.component';
import { TaxInvestmentDetailComponent } from './IncomeTax/TaxInvestment/tax-investment-detail/tax-investment-detail.component';
import { TaxInvestmentApprovalComponent } from './ToDo/TaxInvestmentApproval/tax-investment-approval/tax-investment-approval.component';
import { TaxInvestmentDetailApprovalComponent } from './ToDo/TaxInvestmentApproval/tax-investment-detail-approval/tax-investment-detail-approval.component';
import { EmpchangepasswordComponent } from './Setting/empchangepassword/empchangepassword.component';
import { RegionHeadComponent } from './Setting/ReportingTo/region-head/region-head.component';
import { EmpSiteBranchMappingComponent } from './AttendanceDevice/EmpSiteBranchMapping/emp-site-branch-mapping/emp-site-branch-mapping.component';
import { SiteBranchMappingFormComponent } from './AttendanceDevice/SiteBranchMapping/site-branch-mapping-form/site-branch-mapping-form.component';
import { SiteBranchMappingComponent } from './AttendanceDevice/SiteBranchMapping/site-branch-mapping/site-branch-mapping.component';
import { MyteamComponent } from './MyTeam/myteam/myteam.component';
import { ReporteeAttendanceComponent } from './MyTeam/reportee-attendance/reportee-attendance.component';
import { DashboardFrontComponent } from './Dashboard/dashboard-front/dashboard-front.component';
import { DeviceImageApprovalComponent } from './ToDo/DeviceImageApproval/device-image-approval/device-image-approval.component';
import { DeviceImageApprovalDetailComponent } from './ToDo/DeviceImageApproval/device-image-approval-detail/device-image-approval-detail.component';
import { ProfileImageApprovalComponent } from './ToDo/ProfileImageApproval/profile-image-approval/profile-image-approval.component';
import { ProfileImageApprovalDetailComponent } from './ToDo/ProfileImageApproval/profile-image-approval-detail/profile-image-approval-detail.component';
import { TaxFinancialYearComponent } from './IncomeTax/TaxFinancialYear/tax-financial-year/tax-financial-year.component';
import { MusterAttendanceComponent } from './MusterAttendance/muster-attendance/muster-attendance.component';
import { UserMasterComponent } from './user-master/user-master.component';
import { UserMasterLoadComponent } from './user-master-load/user-master-load.component';
import { UserApplicabilityComponent } from './user-applicability/user-applicability.component';
import { OnlineUserRightsComponent } from './online-user-rights/online-user-rights.component';
import { UserApplicabilityLoadComponent } from './user-applicability-load/user-applicability-load.component';
import { MailApprovalComponent } from './Component/mail-approval/mail-approval.component';
import { AdminTaxUserListComponent } from './IncomeTax/admin-tax-user-list/admin-tax-user-list.component';
import { WebMonthAttendanceBackComponent } from './web-month-attendance-back/web-month-attendance-back.component';
import { AdminRegularizationComponent } from './admin-regularization/admin-regularization.component';
import { AdminRegularizationFormComponent } from './admin-regularization-form/admin-regularization-form.component';
import { SubContractorComponent } from './Register/SubContractor/sub-contractor/sub-contractor.component';
import { SubContractorFormComponent } from './Register/SubContractor/sub-contractor-form/sub-contractor-form.component';
import { EmployeeMultisiteComponent } from './Register/EmployeeMultisite/employee-multisite/employee-multisite.component';
import { AdminLeaveComponent } from './admin-leave/admin-leave.component';
import { AdminLeaveFormComponent } from './admin-leave-form/admin-leave-form.component';
import { PostingOrderViewComponent } from './posting-order-view/posting-order-view.component';
import { PostingOrderFormComponent } from './posting-order-form/posting-order-form.component';
import { TransferOrderViewComponent } from './transfer-order-view/transfer-order-view.component';
import { TransferOrderFormComponent } from './transfer-order-form/transfer-order-form.component';
import { TransferOrderToBranchViewComponent } from './transfer-order-to-branch-view/transfer-order-to-branch-view.component';
import { TransferOrderToBranchFormComponent } from './transfer-order-to-branch-form/transfer-order-to-branch-form.component';
import { BackgroundVerificationPolicyComponent } from './Setting/BackgroundVerificationPolicy/background-verification-policy/background-verification-policy.component';
import { BackgroundVerificationPolicyFormComponent } from './Setting/BackgroundVerificationPolicy/background-verification-policy-form/background-verification-policy-form.component';
import { AllotmentDeleteComponent } from './allotment-delete/allotment-delete.component';
import { AllotmentHistoryReportComponent } from './allotment-history-report/allotment-history-report.component';
import { BGVCheckListComponent } from './Master/BGVCheckList/bgvcheck-list/bgvcheck-list.component';
import { BGVCheckListFormComponent } from './Master/BGVCheckList/bgvcheck-list-form/bgvcheck-list-form.component';
import { DailyAttendance2Component } from './daily-attendance2/daily-attendance2.component';
import { AdminCompOffComponent } from './admin-comp-off/admin-comp-off.component';
import { AdminCompOffFormComponent } from './admin-comp-off-form/admin-comp-off-form.component';
import { AdminCompOffConsumeComponent } from './admin-comp-off-consume/admin-comp-off-consume.component';
import { AdminCompOffConsumeFormComponent } from './admin-comp-off-consume-form/admin-comp-off-consume-form.component';
import { LeaveDualPolicyComponent } from './Setting/LeaveDualPolicy/leave-dual-policy/leave-dual-policy.component';
import { LeaveDualPolicyFormComponent } from './Setting/LeaveDualPolicy/leave-dual-policy-form/leave-dual-policy-form.component';
import { DeviceComponent } from './AttendanceDevice/Device/device/device.component';
import { ExceptionalDaysComponent } from './exceptional-days/exceptional-days.component';
import { ExceptionalDaysFormComponent } from './exceptional-days-form/exceptional-days-form.component';
import { DeviceAttendanceComponent } from './AttendanceDevice/Device/device-attendance/device-attendance.component';
import { DeviceEmployeeAttendanceComponent } from './AttendanceDevice/Device/device-employee-attendance/device-employee-attendance.component';
import { DeviceEmployeeComponent } from './AttendanceDevice/Device/device-employee/device-employee.component';
import { DeviceConfigurationComponent } from './AttendanceDevice/Device/device-configuration/device-configuration.component';
import { ClientAllTicketsComponent } from './client-all-tickets/client-all-tickets.component';
import { ClientAssignedTicketsComponent } from './client-assigned-tickets/client-assigned-tickets.component';
import { ClientHelpdeskReportComponent } from './client-helpdesk-report/client-helpdesk-report.component';
import { UploadFormComponent } from './Component/Upload/upload-form/upload-form.component';
import { UploadComponent } from './Component/Upload/upload/upload.component';
import { SiteDateWiseManpowerFrontComponent } from './Component/Report/site-date-wise-manpower-front/site-date-wise-manpower-front.component';
import { ESSDeviceDuplicateFrontComponent } from './Component/Report/essdevice-duplicate-front/essdevice-duplicate-front.component';
import { SalaryBillingRatecontractComponent } from './RateContract/salary-billing-ratecontract/salary-billing-ratecontract.component';
import { AdminLeaveManagementComponent } from './admin-leave-management/admin-leave-management.component';
import { ZingHRComponent } from './Register/ZingHR/zing-hr/zing-hr.component';
import { SeparationPolicyComponent } from './separation-policy/separation-policy.component';
import { EmployeeResignComponent } from './employee-resign/employee-resign.component';
import { ResignationReasonMasterComponent } from './resignation-reason-master/resignation-reason-master.component';
import { ResignationapprovalComponent } from './resignationapproval/resignationapproval.component';
import { EmployeeTerminationComponent } from './employee-termination/employee-termination.component';
import { EmployeeTerminationFormComponent } from './employee-termination-form/employee-termination-form.component';
import { LeavePoliciesFormNewComponent } from './leave-policies-form-new/leave-policies-form-new.component';
import { ZingHRPostingOrderAddComponent } from './Component/ZingHRPostingOrder/zing-hrposting-order-add/zing-hrposting-order-add.component';
import { ZingHRPostingOrderComponent } from './Component/ZingHRPostingOrder/zing-hrposting-order/zing-hrposting-order.component';
import { LeaveClosingBalanceComponent } from './leave-closing-balance/leave-closing-balance.component';
import { LeaveClosingBalanceBackComponent } from './leave-closing-balance-back/leave-closing-balance-back.component';
import { EmployeeDashboardComponent } from './employee-dashboard/employee-dashboard.component';
import { EmployeeDashboard2Component } from './employee-dashboard2/employee-dashboard2.component';
import { SeparationPolicyViewComponent } from './separation-policy-view/separation-policy-view.component';
import { ZingHRReportComponent } from './Register/ZingHR/zing-hrreport/zing-hrreport.component';

export const routes: Routes = [
  // {
  //     path: '', component: MainLayoutComponent,
  // }, 
  //{
  //     path: '', component: MainLayout2Component,
  // },
  // {
  //     path: '', component: MainLayout3Component,
  // }
  // {
  //     path: '', component: MainLayout4Component,
  // }

  { path: '', component: LoginComponent },
  { path: 'login', component: LoginComponent },
  {
    path:
      'notification'
    , canActivate: [AuthGuardService], component: NotificationComponent
  },
  {
    path: '', canActivate: [AuthGuardService], component: ModuleLayoutComponent,
    children: [
      { path: 'module', component: ModulesListComponent },
    ]
  },
  {
    path: '', canActivate: [AuthGuardService], component: MainLayout3Component,
    children: [
      { path: '', canActivate: [AuthGuardService], component: HomeComponent, pathMatch: 'full' },
      {
        path: 'home',
        children: [
          { path: '', canActivate: [AuthGuardService], component: HomeComponent },
        ]
      },
      {
        path: 'dashboard',
        children: [
          { path: 'front', canActivate: [AuthGuardService], component: DashboardComponent },
          { path: 'frontnew', canActivate: [AuthGuardService], component: DashboardFrontComponent },
          { path: 'back', canActivate: [AuthGuardService], component: DashboardBackComponent },
        ]
      },
      {
        path: 'holidaylist', canActivate: [AuthGuardService], component: HolidayListOnIDComponent,
      },
      {
        path: 'master',
        children: [
          {
            path: 'userdetail',
            children: [
              {
                path: 'usermaster',
                children: [
                  { path: '', canActivate: [AuthGuardService], component: UserMasterLoadComponent },
                  { path: 'add/:id', canActivate: [AuthGuardService], component: UserMasterComponent }
                ],
              },
              {
                path: 'onlineuserrights', canActivate: [AuthGuardService], component: OnlineUserRightsComponent
              },
              {
                path: 'applicability',
                children: [
                  { path: '', canActivate: [AuthGuardService], component: UserApplicabilityLoadComponent },
                  { path: ':id', canActivate: [AuthGuardService], component: UserApplicabilityComponent }
                ]
              },
            ]
          },
          {
            path: 'shift',
            children: [
              { path: '', canActivate: [AuthGuardService], component: ShiftComponent },
              { path: 'add/:id', canActivate: [AuthGuardService], component: ShiftFormComponent },
            ]
          },
          {
            path: 'location',
            children: [
              { path: '', canActivate: [AuthGuardService], component: LocationViewComponent },
            ]
          },
          {
            path: 'locationmap',
            children: [
              { path: '', canActivate: [AuthGuardService], component: LocationMasterNewComponent },
            ]
          },
          {
            path: 'Client',
            children: [
              { path: '', canActivate: [AuthGuardService], component: ClientGroupMasterComponent },
            ]
          },
          {
            path: 'ClientView',
            children: [
              { path: '', canActivate: [AuthGuardService], component: ClientGroupViewComponent },
            ]
          },
          {
            path: 'AdditionOfManpower', canActivate: [AuthGuardService], component: AdditionOfManpowerComponent,
          },
          {
            path: 'AdditionOfManpowerNew/:id/:type/:bid/:cid/:sid', canActivate: [AuthGuardService], component: AdditionOfManpowerNewComponent,
          },
          {
            path: 'AdditionOfManpowerNew/:id/:type', canActivate: [AuthGuardService], component: AdditionOfManpowerNewComponent,
          },
          {
            path: 'ReductionOfManpower', canActivate: [AuthGuardService], component: ReductionOfManpowerComponent,
          },
          {
            path: 'ReductionOfManpowerNew/:id/:type/:bid/:cid/:sid', canActivate: [AuthGuardService], component: ReductionOfManpowerNewComponent,
          },
          {
            path: 'ReductionOfManpowerNew/:id/:type', canActivate: [AuthGuardService], component: ReductionOfManpowerNewComponent,
          },
          {
            path: 'ManPowerAlteration', canActivate: [AuthGuardService], component: ManpowerAlterationFormComponent,
          },
          {
            path: 'ViewAllocateManpower', canActivate: [AuthGuardService], component: ViewOfAllocateManpowerComponent,
          },
          {
            path: 'ViewAllocateManpowerNew', canActivate: [AuthGuardService], component: ViewOfAllocateManpowerNewComponent,
          },
          {
            path: 'ViewAllocateManpowerNew/:bid/:cid/:sid', canActivate: [AuthGuardService], component: ViewOfAllocateManpowerNewComponent,
          },
          {
            path: 'GeoMapping', canActivate: [AuthGuardService], component: GeoMappingComponent,
          },
          {
            path: 'SiteGeoMapping', canActivate: [AuthGuardService], component: SiteGeoMappingComponent,
          },
          {
            path: 'BranchGeoMapping', canActivate: [AuthGuardService], component: BranchGeoMappingComponent,
          },
          {
            path: 'MultipleLocationGeoMapping', canActivate: [AuthGuardService], component: MultipleLocationGeoMappingComponent,
          },
          {
            path: 'LeaveForm', canActivate: [AuthGuardService], component: LeavFormComponent,
          },
          {
            path: 'LeaveView', canActivate: [AuthGuardService], component: LeaveViewComponent,
          },
          {
            path: 'sitewisemanpowersummary',
            children: [
              { path: '', canActivate: [AuthGuardService], component: SiteWiseManpowerSummaryNewComponent },
            ]
          },
          {
            path: 'sitewisemanpowersummarynew',
            children: [
              { path: '', canActivate: [AuthGuardService], component: SiteWiseManpowerSummaryNewComponent },
            ]
          },
          {
            path: 'holiday',
            children: [
              { path: 'holiday', canActivate: [AuthGuardService], component: HolidayComponent },
              { path: 'company', canActivate: [AuthGuardService], component: CompanyHolidayComponent },
              {
                path: 'state',
                children: [
                  { path: '', canActivate: [AuthGuardService], component: StateHolidayFormComponent },
                  { path: 'add/:id/:year', canActivate: [AuthGuardService], component: StateHolidayComponent }
                ]
              },
              {
                path: 'client',
                children: [
                  { path: '', canActivate: [AuthGuardService], component: ClientHolidayFormComponent },
                  { path: 'add/:id', canActivate: [AuthGuardService], component: ClientHolidayComponent }
                ]
              },
              {
                path: 'site',
                children: [
                  { path: '', canActivate: [AuthGuardService], component: SiteHolidayFormComponent },
                  { path: 'add/:id', canActivate: [AuthGuardService], component: SiteHolidayComponent }
                ]
              },
              {
                path: 'branch',
                children: [
                  { path: '', canActivate: [AuthGuardService], component: BranchHolidayComponent },
                  { path: 'add/:id/:year', canActivate: [AuthGuardService], component: BranchHolidayFormComponent }
                ]
              },
              {
                path: 'state',
                children: [
                  { path: '', canActivate: [AuthGuardService], component: StateHolidayFormComponent },
                  { path: 'add/:id/:year', canActivate: [AuthGuardService], component: StateHolidayComponent }
                ]
              },
            ]
          },
          // { path: 'companypolicytype', canActivate: [AuthGuardService], component: CompanyPolicyTypeComponent },
          { path: 'role', canActivate: [AuthGuardService], component: RoleComponent },
          { path: 'tat', canActivate: [AuthGuardService], component: TATComponent },
          {
            path: 'shiftgroup',
            children: [
              { path: '', canActivate: [AuthGuardService], component: ShiftGroupComponent },
            ]
          },
          {
            path: 'reason',
            children: [
              { path: '', canActivate: [AuthGuardService], component: ReasonComponent },
            ]
          },
          {
            path: 'cluster',
            children: [
              { path: '', canActivate: [AuthGuardService], component: ClusterComponent },
              //{ path: 'add/:id', canActivate: [AuthGuardService], component: ClusterFormComponent },
            ]
          },
          {
            path: 'route',
            children: [
              { path: '', canActivate: [AuthGuardService], component: RouteComponent },
              { path: 'add/:id', canActivate: [AuthGuardService], component: RouteFormComponent },
            ]
          },
          {
            path: 'uploadpf',
            children: [
              { path: '', canActivate: [AuthGuardService], component: UploadDocFormComponent, data: { type: 'PF' } },
            ]
          },
          {
            path: 'uploaduan',
            children: [
              { path: '', canActivate: [AuthGuardService], component: UploadDocFormComponent, data: { type: 'UAN' } },
            ]
          },
          {
            path: 'uploadesic',
            children: [
              { path: '', canActivate: [AuthGuardService], component: UploadDocFormComponent, data: { type: 'ESIC' } },
            ]
          },
          {
            path: 'uploadlin',
            children: [
              { path: '', canActivate: [AuthGuardService], component: UploadDocFormComponent, data: { type: 'LIN' } },
            ]
          },
          {
            path: 'sitetype',
            children: [
              { path: '', canActivate: [AuthGuardService], component: SiteTypeComponent },
            ]
          },
          {
            path: 'bgvchecklist',
            children: [
              { path: '', canActivate: [AuthGuardService], component: BGVCheckListComponent },
              { path: 'add/:id', canActivate: [AuthGuardService], component: BGVCheckListFormComponent },
            ]
          },
        ]
      },
      {
        path: 'onboarding',
        children: [
          {
            path: 'register',
            children: [
              { path: 'front', canActivate: [AuthGuardService], component: RegisterComponent },
              { path: 'back', canActivate: [AuthGuardService], component: RegisterComponent },
              { path: 'menualinit/:id/:type', canActivate: [AuthGuardService], component: RegisterInitFormComponent },
              { path: 'add/:id/:draft', canActivate: [AuthGuardService], component: RegisterFormComponent },
              { path: 'detail/:id/:draft', canActivate: [AuthGuardService], component: RegisterDetailComponent },
              { path: 'preonboardingsetup/:id', canActivate: [AuthGuardService], component: RegisterPreonbordingSetupComponent },
              { path: 'CompanyEmpDetails/:id', canActivate: [AuthGuardService], component: CompanyEmployeeDetailsComponent },
            ]
          }, {
            path: 'mobileregister',
            children: [
              { path: '', canActivate: [AuthGuardService], component: MobileRegisterComponent },
              { path: 'add/:id/:draft', canActivate: [AuthGuardService], component: RegisterFormComponent },
              { path: 'detail/:id/:draft', canActivate: [AuthGuardService], component: RegisterDetailComponent },
            ]
          }, {
            path: 'preonboarding',
            children: [
              { path: 'front', canActivate: [AuthGuardService], component: PreOnboardingComponent },
              { path: 'back', canActivate: [AuthGuardService], component: PreOnboardingComponent },
              { path: 'preinit/:id/:type', canActivate: [AuthGuardService], component: RegisterInitFormComponent },
              { path: 'add/:id/:draft', canActivate: [AuthGuardService], component: RegisterFormComponent },
              { path: 'detail/:id/:draft', canActivate: [AuthGuardService], component: RegisterDetailComponent },
              { path: 'preonboardingsetup/:id', canActivate: [AuthGuardService], component: RegisterPreonbordingSetupComponent },
            ]
          }, {
            path: 'candidateinitiation',
            children: [
              { path: 'front', canActivate: [AuthGuardService], component: CandidateInitiationComponent },
              { path: 'back', canActivate: [AuthGuardService], component: CandidateInitiationComponent },
              { path: 'add/:id/:draft', canActivate: [AuthGuardService], component: RegisterFormComponent },
              { path: 'detail/:id/:draft', canActivate: [AuthGuardService], component: RegisterDetailComponent },
              { path: 'preonboardingsetup/:id', canActivate: [AuthGuardService], component: RegisterPreonbordingSetupComponent },
            ]
          },
          {
            path: 'IDCard',
            children: [
              { path: 'front', canActivate: [AuthGuardService], component: IDCardFrontReportComponent, data: { type: 'IDCard' } },
              { path: 'back', canActivate: [AuthGuardService], component: IDCardFrontReportComponent, data: { type: 'IDCard' } },
            ]
          },
          {
            path: 'biodata',
            children: [
              { path: 'front', canActivate: [AuthGuardService], component: IDCardFrontReportComponent, data: { type: 'Biodata' } },
              { path: 'back', canActivate: [AuthGuardService], component: IDCardFrontReportComponent, data: { type: 'Biodata' } },
            ]
          },
          {
            path: 'approvaldetails',
            children: [
              { path: 'front', canActivate: [AuthGuardService], component: ApprovalDetailsComponent },
              { path: 'back', canActivate: [AuthGuardService], component: ApprovalDetailsComponent },
            ]
          },
          {
            path: 'empattendancemerge',
            children: [
              { path: 'front', canActivate: [AuthGuardService], component: EmpAttendanceMergeComponent },
              { path: 'back', canActivate: [AuthGuardService], component: EmpAttendanceMergeComponent },
            ]
          },
          {
            path: 'subcontractor',
            children: [
              { path: '', canActivate: [AuthGuardService], component: SubContractorComponent },
              { path: 'add/:id', canActivate: [AuthGuardService], component: SubContractorFormComponent },
            ]
          },
          {
            path: 'zinghr',
            children: [
              { path: '', canActivate: [AuthGuardService], component: ZingHRComponent },
              { path: 'add/:id/:draft', canActivate: [AuthGuardService], component: RegisterFormComponent },
              { path: 'detail/:id/:draft', canActivate: [AuthGuardService], component: RegisterDetailComponent },
              { path: 'report', canActivate: [AuthGuardService], component: ZingHRReportComponent },
            ]
          }
        ]
      },
      {
        path: 'MISMaster',
        children: [
          {
            path: 'countrymaster', canActivate: [AuthGuardService], component: AllMastersComponent,
          },
          {
            path: 'gunmaster', canActivate: [AuthGuardService], component: AllMastersComponent,
          },
          {
            path: 'reason', canActivate: [AuthGuardService], component: AllMastersComponent,
          },
          {
            path: 'color', canActivate: [AuthGuardService], component: AllMastersComponent,
          },
          {
            path: 'uniform', canActivate: [AuthGuardService], component: AllMastersComponent,

          },
          {
            path: 'shoe', canActivate: [AuthGuardService], component: AllMastersComponent,

          },
          {
            path: 'designationgrp', canActivate: [AuthGuardService], component: AllMastersComponent,

          },
          {
            path: 'qualification', canActivate: [AuthGuardService], component: AllMastersComponent,

          },
          {
            path: 'religion', canActivate: [AuthGuardService], component: AllMastersComponent,

          },
          {
            path: 'mother', canActivate: [AuthGuardService], component: AllMastersComponent,

          },
          {
            path: 'relationship', canActivate: [AuthGuardService], component: AllMastersComponent,

          },
          {
            path: 'caste', canActivate: [AuthGuardService], component: AllMastersComponent,

          },
          {
            path: 'nationality', canActivate: [AuthGuardService], component: AllMastersComponent,

          },
          {
            path: 'language', canActivate: [AuthGuardService], component: AllMastersComponent,

          },
          {
            path: 'designationctgry', canActivate: [AuthGuardService], component: AllMastersComponent,

          },
          {
            path: 'report', canActivate: [AuthGuardService], component: AllMastersComponent,
          },
          {
            path: 'group', canActivate: [AuthGuardService], component: AllMastersComponent,
          },
          {
            path: 'duty', canActivate: [AuthGuardService], component: AllMastersComponent,
          },
          {
            path: 'rateapplication', canActivate: [AuthGuardService], component: AllMastersComponent,
          },
        ]
      },
      {
        path: 'setting',
        children: [
          {
            path: 'approvalmatrix',
            children: [
              { path: '', canActivate: [AuthGuardService], component: ApprovalMatrixComponent },
              { path: 'add/:id', canActivate: [AuthGuardService], component: ApprovalMatrixFormComponent },
            ]
          },
          {
            path: 'attendancepolicies',
            children: [
              { path: '', canActivate: [AuthGuardService], component: AttendancePoliciesComponent },
              { path: 'add/:id', canActivate: [AuthGuardService], component: AttendancePoliciesFormComponent },
            ]
          },
          {
            path: 'regularizationpolicies',
            children: [
              { path: '', canActivate: [AuthGuardService], component: RegularizationPoliciesComponent },
              { path: 'add/:id', canActivate: [AuthGuardService], component: RegularizationPoliciesFormComponent },
            ]
          },
          {
            path: 'weekoffpolicies',
            children: [
              { path: '', canActivate: [AuthGuardService], component: WeekOffPoliciesComponent },
              { path: 'add/:id', canActivate: [AuthGuardService], component: WeekOffPoliciesFormComponent },
            ]
          },
          {
            path: 'shiftpolicies',
            children: [
              { path: '', canActivate: [AuthGuardService], component: ShiftPoliciesComponent },
              { path: 'add/:id', canActivate: [AuthGuardService], component: ShiftPoliciesFormComponent },
            ]
          },
          {
            path: 'leavepolicies',
            children: [
              { path: '', canActivate: [AuthGuardService], component: LeavePoliciesComponent },
              { path: 'add/:id', canActivate: [AuthGuardService], component: LeavePoliciesFormComponent },
              { path: 'add2/:id', canActivate: [AuthGuardService], component: LeavePoliciesFormNewComponent },
            ]
          },
          {
            path: 'leavedualpolicies',
            children: [
              { path: '', canActivate: [AuthGuardService], component: LeaveDualPolicyComponent },
              { path: 'add/:bid/:cid/:sid/:lid/:wid', canActivate: [AuthGuardService], component: LeaveDualPolicyFormComponent },
            ]
          },
          {
            path: 'compensatoryoffpolicies',
            children: [
              { path: '', canActivate: [AuthGuardService], component: CompensatoryOffPolicyComponent },
              { path: 'add/:id', canActivate: [AuthGuardService], component: CompensatoryOffPolicyFormComponent },
            ]
          },
          {
            path: 'expensepolicies',
            children: [
              { path: '', canActivate: [AuthGuardService], component: ExpensePolicyComponent },
              { path: 'add/:id', canActivate: [AuthGuardService], component: ExpensePolicyFormComponent },
            ]
          },
          {
            path: 'optionalholidaypolicies',
            children: [
              { path: '', canActivate: [AuthGuardService], component: OptionalHolidayPolicyComponent },
              { path: 'add/:id', canActivate: [AuthGuardService], component: OptionalHolidayPolicyFormComponent },
            ]
          },
          {
            path: 'AttendenceReset', canActivate: [AuthGuardService], component: AttendenceResetComponent,
          },
          {
            path: 'DeviceReset', canActivate: [AuthGuardService], component: DeviceResetComponent,
          },
          {
            path: 'EmpLeaveManagementFront', canActivate: [AuthGuardService], component: EmployeeLeaveManagementComponent,
          },
          {
            path: 'essLoginInitiation', canActivate: [AuthGuardService], component: LoginInitiationComponent,
          },
          {
            path: 'userright', canActivate: [AuthGuardService], component: UserRightComponent,
          },
          {
            path: 'reportingtoemployee', canActivate: [AuthGuardService], component: EmployeeToComponent,
          },
          {
            path: 'reportingtocompanyhead', canActivate: [AuthGuardService], component: CompanyHeadComponent,
          },
          {
            path: 'reportingtobranchhead', canActivate: [AuthGuardService], component: BranchHeadComponent,
          },
          {
            path: 'reportingtositehead', canActivate: [AuthGuardService], component: SiteHeadComponent,
          },
          {
            path: 'reportingtoclienthead', canActivate: [AuthGuardService], component: ClientHeadComponent,
          },
          {
            path: 'IMEISearch', canActivate: [AuthGuardService], component: IMEISearchComponent,
          },
          {
            path: 'ForceCheckOutUtility', canActivate: [AuthGuardService], component: ForceCheckOutUtilityComponent,
          },
          {
            path: 'EmpLeaveManagementBack', canActivate: [AuthGuardService], component: EmployeeLeaveManagementBackComponent,
          },
          {
            path: 'SiteUserRights',
            children: [
              { path: '', canActivate: [AuthGuardService], component: SiteUserRightsComponent },
            ]
          },
          {
            path: 'shiftroster',
            children: [
              { path: '', canActivate: [AuthGuardService], component: ShiftRosterComponent },
            ]
          },
          {
            path: 'employeeconfirmationpolicies',
            children: [
              { path: '', canActivate: [AuthGuardService], component: EmployeeConfirmationPoliciesComponent },
              { path: 'add/:id', canActivate: [AuthGuardService], component: EmployeeConfirmationPoliciesFormComponent },
            ]
          },
          {
            path: 'ForceMobileVerification',
            children: [
              { path: '', canActivate: [AuthGuardService], component: ForceMobileVerificationComponent },
            ]
          },
          {
            path: 'EFSRDownload',
            children: [
              { path: '', canActivate: [AuthGuardService], component: EFSRFileDownloadComponent },
            ]
          },
          { path: 'siteuser', canActivate: [AuthGuardService], component: SiteUserComponent },
          {
            path: 'Reimbursementpolicies',
            children: [
              { path: '', canActivate: [AuthGuardService], component: LTAPolicyComponent },
              { path: 'add/:id', canActivate: [AuthGuardService], component: LTAPolicyFormComponent },
            ]
          },
          {
            path: 'exitpolicies',
            children: [
              { path: '', canActivate: [AuthGuardService], component: SeperationPoliciesComponent },
              { path: 'add/:id', canActivate: [AuthGuardService], component: SeperationPoliciesFormComponent },
            ]
          },
          {
            path: 'outofofficepolicies',
            children: [
              { path: '', canActivate: [AuthGuardService], component: OutOfOfficeComponent },
              { path: 'add/:id', canActivate: [AuthGuardService], component: OutOfOfficeFormComponent },
            ]
          },
          {
            path: 'empchangepassword',
            children: [
              { path: '', canActivate: [AuthGuardService], component: EmpchangepasswordComponent },
            ]
          },
          {
            path: 'reportingtoregion',
            children: [
              { path: '', canActivate: [AuthGuardService], component: RegionHeadComponent },
            ]
          },
          {
            path: 'bgvpolicies',
            children: [
              { path: '', canActivate: [AuthGuardService], component: BackgroundVerificationPolicyComponent },
              { path: 'add/:id', canActivate: [AuthGuardService], component: BackgroundVerificationPolicyFormComponent },
            ]
          },
          {
            path: 'separationpolicy',
            children: [
              {path: '', canActivate: [AuthGuardService], component: SeparationPolicyViewComponent },
              {path: 'add/:id', canActivate: [AuthGuardService], component: SeparationPolicyComponent },
            ]
          },
          { path: 'leaveclosing', canActivate: [AuthGuardService], component: LeaveClosingBalanceComponent },
          { path: 'leaveclosingback', canActivate: [AuthGuardService], component: LeaveClosingBalanceBackComponent },
        ]
      },
      {
        path: 'request',
        children: [
          {
            path: 'leave',
            children: [
              { path: '', canActivate: [AuthGuardService], component: LeaveHistoryComponent },
              { path: 'add/:id', canActivate: [AuthGuardService], component: LeaveRequestFormComponent },
              { path: 'detail/:id', canActivate: [AuthGuardService], component: LeaveApprovalDetailComponent },
              { path: 'approval', canActivate: [AuthGuardService], component: LeaveApprovalComponent },
            ]
          },
          {
            path: 'attendance',
            children: [
              { path: '', canActivate: [AuthGuardService], component: AttendanceComponent },
              { path: 'detail/:id', canActivate: [AuthGuardService], component: AttendanceApprovalDetailComponent },
              { path: 'approval', canActivate: [AuthGuardService], component: AttendanceApprovalComponent },
            ]
          },
          {
            path: 'regularization',
            children: [
              { path: '', canActivate: [AuthGuardService], component: RegularizationComponent },
              { path: 'add/:id', canActivate: [AuthGuardService], component: RegularizationFormComponent },
              { path: 'detail/:id', canActivate: [AuthGuardService], component: RegularizationApprovalDetailComponent },
              { path: 'approval', canActivate: [AuthGuardService], component: RegularizationApprovalComponent },
            ]
          },
          {
            path: 'compensatoryoff',
            children: [
              { path: '', canActivate: [AuthGuardService], component: CompensatoryOffComponent },
              { path: 'add/:id', canActivate: [AuthGuardService], component: CompensatoryOffFormComponent },
              { path: 'detail/:id', canActivate: [AuthGuardService], component: CompensatoryOffApprovalDetailComponent },
              { path: 'approval', canActivate: [AuthGuardService], component: CompensatoryOffApprovalComponent },
            ]
          },
          {
            path: 'compensatoryoffconsume',
            children: [
              { path: '', canActivate: [AuthGuardService], component: CompensatoryOffConsumeComponent },
              { path: 'add/:id', canActivate: [AuthGuardService], component: CompensatoryOffConsumeFormComponent },
              { path: 'detail/:id', canActivate: [AuthGuardService], component: CompensatoryOffConsumeApprovalDetailComponent },
              { path: 'approval', canActivate: [AuthGuardService], component: CompensatoryOffConsumeApprovalComponent },
            ]
          },
          {
            path: 'expense',
            children: [
              { path: '', canActivate: [AuthGuardService], component: ExpenseComponent },
              { path: 'add/:id', canActivate: [AuthGuardService], component: ExpenseFormComponent },
              { path: 'history', canActivate: [AuthGuardService], component: ExpenseHistoryComponent },
              { path: 'detail/:id', canActivate: [AuthGuardService], component: ExpenseApprovalDetailComponent },
              { path: 'approval', canActivate: [AuthGuardService], component: ExpenseApprovalComponent },
            ]
          },
          {
            path: 'advanceexpense',
            children: [
              { path: '', canActivate: [AuthGuardService], component: AdvanceExpenseComponent },
              { path: 'detail/:id', canActivate: [AuthGuardService], component: AdvanceExpenseApprovalDetailComponent },
              { path: 'approval', canActivate: [AuthGuardService], component: AdvanceExpenseApprovalComponent },
            ]
          },
          {
            path: 'outstation',
            children: [
              { path: '', canActivate: [AuthGuardService], component: OutstationComponent },
              { path: 'detail/:id', canActivate: [AuthGuardService], component: ExpenseApprovalDetailComponent },
              { path: 'history', canActivate: [AuthGuardService], component: ExpenseHistoryComponent },
            ]
          },
          {
            path: 'expensetrip',
            children: [
              { path: '', canActivate: [AuthGuardService], component: ExpenseTripComponent },
            ]
          },
          {
            path: 'optionalholiday',
            children: [
              { path: '', canActivate: [AuthGuardService], component: OptionalHolidayComponent },
              { path: 'add/:id', canActivate: [AuthGuardService], component: OptionalHolidayFormComponent },
              { path: 'detail/:id', canActivate: [AuthGuardService], component: OptionalHolidayApprovalDetailComponent },
              { path: 'approval', canActivate: [AuthGuardService], component: OptionalHolidayApprovalComponent },
            ]
          },
          {
            path: 'reimbursement',
            children: [
              { path: '', canActivate: [AuthGuardService], component: ReimbursementLoadComponent },
              { path: 'add/:id', canActivate: [AuthGuardService], component: ReimbursementFormComponent },
              { path: 'detail/:id', canActivate: [AuthGuardService], component: ReimbursementApprovalDetailComponent },
              { path: 'approval', canActivate: [AuthGuardService], component: ReimbursementApprovalComponent },
            ]
          },
          {
            path: 'questionnaire',
            children: [
              { path: '', canActivate: [AuthGuardService], component: EmpConfirmationComponent },
              { path: 'add/:id', canActivate: [AuthGuardService], component: EmpConfirmationDetailComponent },
              { path: 'detail/:id', canActivate: [AuthGuardService], component: EmpConfirmationApprovalDetailComponent },
              { path: 'approval', canActivate: [AuthGuardService], component: EmpConfirmationApprovalComponent },
            ]
          },
          {
            path: 'letter',
            children: [
              { path: 'approval', canActivate: [AuthGuardService], component: LetterApprovalComponent },
            ]
          },
          {
            path: 'EmpProfile',
            children: [
              { path: '', canActivate: [AuthGuardService], component: ProfileDetailsRequestComponent },

            ]
          },
          {
            path: 'outofoffice',
            children: [
              { path: '', canActivate: [AuthGuardService], component: OutOfOfficeLoadComponent },
              { path: 'add/:id', canActivate: [AuthGuardService], component: FormOutOfOfficeComponent },
              { path: 'detail/:id', canActivate: [AuthGuardService], component: OutOfOfficeApprovalDetailComponent },
              { path: 'approval', canActivate: [AuthGuardService], component: OutOfOfficeApprovalComponent },
            ]
          },
          {
            path: 'incometax',
            children: [
              {
                path: 'taxdeclaration', children: [
                  { path: '', canActivate: [AuthGuardService], component: TaxDeclarationComponent },
                  { path: 'add/:id', canActivate: [AuthGuardService], component: TaxDeclarationFormComponent },
                  { path: 'detail/:id', canActivate: [AuthGuardService], component: TaxDeclarationDetailComponent },
                ]
              },
              {
                path: 'taxinvestment', children: [
                  { path: '', canActivate: [AuthGuardService], component: TaxInvestmentComponent },
                  { path: 'add/:id', canActivate: [AuthGuardService], component: TaxInvestmentFormComponent },
                  { path: 'detail/:id', canActivate: [AuthGuardService], component: TaxInvestmentDetailComponent },
                ]
              },
            ]
          }
        ]
      },
      {
        path: 'todo',
        children: [
          {
            path: 'leaveapproval',
            children: [
              { path: '', canActivate: [AuthGuardService], component: LeaveApprovalComponent },
              { path: 'detail/:id', canActivate: [AuthGuardService], component: LeaveApprovalDetailComponent },
            ]
          },
          {
            path: 'regularizationapproval',
            children: [
              { path: '', canActivate: [AuthGuardService], component: RegularizationApprovalComponent },
              { path: 'detail/:id', canActivate: [AuthGuardService], component: RegularizationApprovalDetailComponent },
            ]
          },
          {
            path: 'attendanceapproval',
            children: [
              { path: '', canActivate: [AuthGuardService], component: AttendanceApprovalComponent },
              { path: 'detail/:id', canActivate: [AuthGuardService], component: AttendanceApprovalDetailComponent },
            ]
          },
          {
            path: 'registrationapproval',
            children: [
              { path: '', canActivate: [AuthGuardService], component: RegistrationApprovalComponent },
              { path: 'detail/:id/:mid', canActivate: [AuthGuardService], component: RegistrationApprovalDetailComponent },
              { path: 'mrdetail/:id/:draft', canActivate: [AuthGuardService], component: RegisterDetailComponent },
              { path: 'prdetail/:id/:draft', canActivate: [AuthGuardService], component: RegisterDetailComponent },
            ]
          },
          {
            path: 'opholidayapproval',
            children: [
              { path: '', canActivate: [AuthGuardService], component: OptionalHolidayApprovalComponent },
              { path: 'detail/:id', canActivate: [AuthGuardService], component: OptionalHolidayApprovalDetailComponent },
            ]
          },
          {
            path: 'compensatoryoffapproval',
            children: [
              { path: '', canActivate: [AuthGuardService], component: CompensatoryOffApprovalComponent },
              { path: 'detail/:id', canActivate: [AuthGuardService], component: CompensatoryOffApprovalDetailComponent },
            ]
          },
          {
            path: 'compensatoryoffconsumeapproval',
            children: [
              { path: '', canActivate: [AuthGuardService], component: CompensatoryOffConsumeApprovalComponent },
              { path: 'detail/:id', canActivate: [AuthGuardService], component: CompensatoryOffConsumeApprovalDetailComponent },
            ]
          },
          {
            path: 'reimbursementapproval',
            children: [
              { path: '', canActivate: [AuthGuardService], component: ReimbursementApprovalComponent },
              { path: 'detail/:id', canActivate: [AuthGuardService], component: ReimbursementApprovalDetailComponent },
            ]
          },
          {
            path: 'expenseapproval',
            children: [
              { path: '', canActivate: [AuthGuardService], component: ExpenseApprovalComponent },
              { path: 'detail/:id', canActivate: [AuthGuardService], component: ExpenseApprovalDetailComponent },
            ]
          },
          {
            path: 'advanceapproval',
            children: [
              { path: '', canActivate: [AuthGuardService], component: AdvanceExpenseApprovalComponent },
              { path: 'detail/:id', canActivate: [AuthGuardService], component: AdvanceExpenseApprovalDetailComponent },
            ]
          },
          {
            path: 'employeeconfirmation',
            children: [
              { path: '', canActivate: [AuthGuardService], component: EmpConfirmationApprovalComponent },
              { path: 'detail/:id', canActivate: [AuthGuardService], component: EmpConfirmationApprovalDetailComponent },
            ]
          },
          {
            path: 'letterapproval',
            children: [
              { path: '', canActivate: [AuthGuardService], component: LetterApprovalComponent },
              { path: 'detail/:id', canActivate: [AuthGuardService], component: LetterApprovalDetailComponent },
            ]
          },
          {
            path: 'EmpDetails',
            children: [
              { path: '', canActivate: [AuthGuardService], component: EmpProfileDetailsUpdateComponent },
              //{ path: 'detail/:id', canActivate: [AuthGuardService], component: ProfileRequestDetailComponent },
              { path: 'detail/:type/:id/:eid/:tid', canActivate: [AuthGuardService], component: ProfileRequestDetailComponent },

            ]
          },
          {
            path: 'outofofficeapproval',
            children: [
              { path: '', canActivate: [AuthGuardService], component: OutOfOfficeApprovalComponent },
              { path: 'detail/:id', canActivate: [AuthGuardService], component: OutOfOfficeApprovalDetailComponent },
            ]
          },
          {
            path: 'taxdeclaration',
            children: [
              { path: '', canActivate: [AuthGuardService], component: TaxDeclarationApprovalComponent },
              { path: 'detail/:id', canActivate: [AuthGuardService], component: TaxDeclarationApprovalDetailComponent },
            ]
          },
          {
            path: 'taxinvestment',
            children: [
              { path: '', canActivate: [AuthGuardService], component: TaxInvestmentApprovalComponent },
              { path: 'detail/:id', canActivate: [AuthGuardService], component: TaxInvestmentDetailApprovalComponent },
            ]
          },
          {
            path: 'deviceimage',
            children: [
              { path: '', canActivate: [AuthGuardService], component: DeviceImageApprovalComponent },
              { path: 'detail/:id', canActivate: [AuthGuardService], component: DeviceImageApprovalDetailComponent },
            ]
          },
          {
            path: 'profileimage',
            children: [
              { path: '', canActivate: [AuthGuardService], component: ProfileImageApprovalComponent },
              { path: 'detail/:id', canActivate: [AuthGuardService], component: ProfileImageApprovalDetailComponent },
            ]
          },
        ]
      },
      {
        path: 'feed',
        children: [
          { path: '', canActivate: [AuthGuardService], component: FeedListComponent },
          { path: 'add/:id', canActivate: [AuthGuardService], component: FeedComponent },
        ]
      },
      {
        path: 'Asset',
        children: [
          {
            path: 'assetgroup',
            children: [
              { path: '', canActivate: [AuthGuardService], component: AssetGroupMasterComponent },
              { path: 'add/:id', canActivate: [AuthGuardService], component: AssetGroupMasterFormComponent },
            ]
          },
          {
            path: 'assetmaster',
            children: [
              { path: '', canActivate: [AuthGuardService], component: AssetMasterComponent },
              { path: 'add/:id', canActivate: [AuthGuardService], component: AssetMasterFormComponent },
            ]
          },
          {
            path: 'assetaddition',
            children: [
              { path: '', canActivate: [AuthGuardService], component: AssetAdditionComponent },
              { path: 'add/:id', canActivate: [AuthGuardService], component: AssetAdditionFormComponent },
            ]
          },
          {
            path: 'assetadditionDetail',
            children: [
              { path: '', canActivate: [AuthGuardService], component: AssetAdditionalDetailComponent },
              { path: 'add/:id', canActivate: [AuthGuardService], component: AssetAdditionalDetailComponent },
            ]
          },
          {
            path: 'assetTransfer',
            children: [
              { path: '', canActivate: [AuthGuardService], component: AssetTransferComponent },
              { path: 'add/:id', canActivate: [AuthGuardService], component: AssetTransferFormComponent },
            ]
          },
          {
            path: 'assetAllotment',
            children: [
              { path: '', canActivate: [AuthGuardService], component: AssetAllotmentComponent },
              { path: 'add/:id', canActivate: [AuthGuardService], component: AssetAllotmentFormComponent },
            ]
          },

        ]
      },
      {
        path: 'reports',
        children: [
          {
            path: 'report',
            children: [
              { path: '', canActivate: [AuthGuardService], component: FroceCheckOutUtilityLogReportsComponent },
              { path: 'view/:type/:id', canActivate: [AuthGuardService], component: CommonReportComponent },
            ]
          },
          {
            path: 'ForceCheckOut',
            children: [
              { path: '', canActivate: [AuthGuardService], component: FroceCheckOutUtilityLogReportsComponent },
            ]
          },
          {
            path: 'EmpwiseMonthAttendance',
            children: [
              { path: '', canActivate: [AuthGuardService], component: MonthlyAttendenceDetailsEmpwiseLogComponent },
            ]
          },
          {
            path: 'frontEmpmonthAttendance',
            children: [
              { path: '', canActivate: [AuthGuardService], component: MonthlyAttendenceDetailsEmpFrontLogComponent },
            ]
          },
          {
            path: 'BackEmpmonthAttendance',
            children: [
              { path: '', canActivate: [AuthGuardService], component: MonthlyAttendenceDetailsEmpBackLogComponent },
            ]
          },
          {
            path: 'LeaveDetailEmpWise',
            children: [
              { path: '', canActivate: [AuthGuardService], component: LeaveDetailEmpwiseLogComponent },
            ]
          },
          {
            path: 'LeaveDetailFront',
            children: [
              { path: '', canActivate: [AuthGuardService], component: LeaveDetailFrontLogComponent },
            ]
          },
          {
            path: 'LeaveDetailBack',
            children: [
              { path: '', canActivate: [AuthGuardService], component: LeaveDetailBackLogComponent },
            ]
          },
          {
            path: 'RegularizeEmpWise',
            children: [
              { path: '', canActivate: [AuthGuardService], component: RegularizeEmpwiseLogComponent },
            ]
          },
          {
            path: 'RegularizeFront',
            children: [
              { path: '', canActivate: [AuthGuardService], component: RegularizeFrontLogComponent },
            ]
          },
          {
            path: 'RegularizeBack',
            children: [
              { path: '', canActivate: [AuthGuardService], component: RegularizeBackLogComponent },
            ]
          },
          {
            path: 'InstalledEmpFront',
            children: [
              { path: '', canActivate: [AuthGuardService], component: InstalledEmpFrontComponent },
            ]
          },
          {
            path: 'InstalledEmpBack',
            children: [
              { path: '', canActivate: [AuthGuardService], component: InstalledEmpBackComponent },
            ]
          },
          {
            path: 'DuplicateDevicePunchingDetailsBack',
            children: [
              { path: '', canActivate: [AuthGuardService], component: DuplicateDevicePunchingDetailsBackComponent },
            ]
          },
          {
            path: 'DuplicateDevicePunchingDetailsFront',
            children: [
              { path: '', canActivate: [AuthGuardService], component: DuplicateDevicePunchingDetailsFrontComponent },
            ]
          },
          {
            path: 'OtherDutyFront',
            children: [
              { path: '', canActivate: [AuthGuardService], component: OtherDutyDetailFrontComponent },
            ]
          },
          {
            path: 'OtherDutyBack',
            children: [
              { path: '', canActivate: [AuthGuardService], component: OtherDutyDetailBackComponent },
            ]
          },
          {
            path: 'frontreport',
            children: [
              { path: '', canActivate: [AuthGuardService], component: FrontReportComponent },
            ]
          },
          {
            path: 'backreport',
            children: [
              { path: '', canActivate: [AuthGuardService], component: BackReportComponent },
            ]
          },
          {
            path: 'empreport',
            children: [
              { path: '', canActivate: [AuthGuardService], component: EmployeeReportComponent },
            ]
          },
          {
            path: 'OpHolidayFront',
            children: [
              { path: '', canActivate: [AuthGuardService], component: OptionalHolidayReportFrontComponent },
            ]
          },
          {
            path: 'OpHolidayBack',
            children: [
              { path: '', canActivate: [AuthGuardService], component: OptionalHolidayReportBackComponent },
            ]
          },
          {
            path: 'OpHolidayEmpWise',
            children: [
              { path: '', canActivate: [AuthGuardService], component: OptionalHolidayReportEmpWiseComponent },
            ]
          },
          {
            path: 'SiteDateWiseManpowerFront',
            children: [
              { path: '', canActivate: [AuthGuardService], component: SiteDateWiseManpowerFrontComponent },
            ]
          },
          {
            path: 'ESSDeviceDuplicateFront',
            children: [
              { path: '', canActivate: [AuthGuardService], component: ESSDeviceDuplicateFrontComponent },
            ]
          },
        ]
      },
      {
        path: 'HelpDesk',
        children: [
          {
            path: 'Ticket',
            children: [
              { path: '', canActivate: [AuthGuardService], component: SupportTicketComponent },
            ]
          },
          {
            path: 'TicketAssign',
            children: [
              { path: '', canActivate: [AuthGuardService], component: TicketAssignComponent },
            ]
          },
          {
            path: 'helpdeskreport',
            children: [
              { path: '', canActivate: [AuthGuardService], component: HelpDeskReportsComponent },
              // { path: 'back', canActivate: [AuthGuardService], component: HelpDeskReportsComponent },
            ]
          },
        ]
      },
      {
        path: 'expense',
        children: [
          {
            path: 'category',
            children: [
              { path: '', canActivate: [AuthGuardService], component: ExpenseCategoryComponent },
            ]
          },
          {
            path: 'vehicle',
            children: [
              { path: '', canActivate: [AuthGuardService], component: VehicleComponent },
            ]
          },
          {
            path: 'reimbursement',
            children: [
              { path: '', canActivate: [AuthGuardService], component: ExpenseReimbursementComponent },
            ]
          },
          {
            path: 'localreimbursement',
            children: [
              { path: '', canActivate: [AuthGuardService], component: LocalReimbursementComponent },
            ]
          },
        ]
      },
      {
        path: 'employeeconfirmation',
        children: [
          // {
          //   path: 'templet',
          //   children: [
          //     { path: '', canActivate: [AuthGuardService], component: EmpConfirmationTemplateComponent },
          //     { path: 'add/:id', canActivate: [AuthGuardService], component: EmpConfirmationTemplateFormComponent },
          //   ]
          // },
          //
          // {
          //   path: 'Questionnaire',
          //   children: [
          //     { path: '', canActivate: [AuthGuardService], component: QusetionnarieFormComponent },
          //   ]
          // },
          {
            path: 'Questionnaire',
            children: [
              { path: '', canActivate: [AuthGuardService], component: QuestionnaireComponent },
              { path: 'add/:id', canActivate: [AuthGuardService], component: QusetionnarieFormComponent },
            ]
          },
          {
            path: 'ConfirmationEmpDetails',
            children: [
              { path: '', canActivate: [AuthGuardService], component: ConfirmationEmpDetailsComponent },
            ]
          },
          {
            path: 'empconfirmationbulk',
            children: [
              { path: '', canActivate: [AuthGuardService], component: EmpConfirmationBulkComponent },
            ]
          },
        ]
      },
      {
        path: 'letter',
        children: [
          {
            path: 'letterdocumenttype',
            children: [
              { path: '', canActivate: [AuthGuardService], component: LetterDocumentTypeComponent },
            ]
          },
          {
            path: 'lettertemplate',
            children: [
              { path: '', canActivate: [AuthGuardService], component: LetterTemplateComponent },
            ]
          },
          {
            path: 'letterupload',
            children: [
              { path: '', canActivate: [AuthGuardService], component: LetterTemplateUploadComponent },
            ]
          },
          {
            path: 'lettergenerate',
            children: [
              { path: '', canActivate: [AuthGuardService], component: LetterGenerateFormComponent },
            ]
          },
          {
            path: 'letterreport',
            children: [
              { path: '', canActivate: [AuthGuardService], component: LetterGenerateComponent },
            ]
          },
          {
            path: 'empletter',
            children: [
              { path: '', canActivate: [AuthGuardService], component: EmployeeLetterComponent },
            ]
          },
        ]
      },
      {
        path: 'myteam',
        children: [
          { path: '', canActivate: [AuthGuardService], component: MyteamComponent },
        ]
      },
      {
        path: 'ReporteeAttendance',
        children: [
          { path: '', canActivate: [AuthGuardService], component: ReporteeAttendanceComponent },
        ]
      },
      {
        path: 'companydocument',
        children: [
          {
            path: 'document',
            children: [
              { path: '', canActivate: [AuthGuardService], component: CompanyDocumentComponent },
            ]
          },
          {
            path: 'companypolicymaster',
            children: [
              { path: '', canActivate: [AuthGuardService], component: CompanyPolicyMasterComponent },
              { path: 'add/:id', canActivate: [AuthGuardService], component: CompanyPolicyMasterFormComponent },
            ]
          },
          { path: 'companypolicytype', canActivate: [AuthGuardService], component: CompanyPolicyTypeComponent },
        ]
      },
      {
        path: 'reimbursement',
        children: [
          {
            path: 'claimed',
            children: [
              { path: '', canActivate: [AuthGuardService], component: ClaimedReimbursementComponent },
            ]
          },
          {
            path: 'pay',
            children: [
              { path: '', canActivate: [AuthGuardService], component: PayReimbursementComponent },
            ]
          },
        ]
      },
      {
        path: 'exit',
        children: [
          { path: '', canActivate: [AuthGuardService], component: SeperateFormComponent },
        ]
      },
      {
        path: 'webattendance',
        children: [
          {
            path: 'dailyattendance',
            children: [
              { path: '', canActivate: [AuthGuardService], component: DailyAttendanceComponent },
            ]
          },
          {
            path: 'monthattendance',
            children: [
              { path: '', canActivate: [AuthGuardService], component: WebMonthAttendanceComponent },
            ]
          },
          {
            path: 'monthattendanceback',
            children: [
              { path: '', canActivate: [AuthGuardService], component: WebMonthAttendanceBackComponent },
            ]
          },
          {
            path: 'dailyempattendance',
            children: [
              { path: '', canActivate: [AuthGuardService], component: DailyAttendance2Component },
            ]
          },
          {
            path: 'attendancemanagement',
            children: [
              { path: '', canActivate: [AuthGuardService], component: AdminLeaveManagementComponent },
            ]
          }
        ]
      },

      {
        path: 'incometax',
        children: [
          { path: 'taxcategory', canActivate: [AuthGuardService], component: TaxCategoryComponent },
          { path: 'taxcategoryslab', canActivate: [AuthGuardService], component: TaxCategorySlabComponent },
          { path: 'taxsection', canActivate: [AuthGuardService], component: TaxSectionComponent },
          { path: 'taxsubsection', canActivate: [AuthGuardService], component: TaxSubSectionComponent },
          { path: 'preview', canActivate: [AuthGuardService], component: TaxDeclarationPreviewComponent },
          { path: 'compare/:type/:id', canActivate: [AuthGuardService], component: TaxDeclarationCompareComponent },
          { path: 'taxfinancialyear', canActivate: [AuthGuardService], component: TaxFinancialYearComponent },
          {
            path: 'incometax',
            children: [
              { path: '', canActivate: [AuthGuardService], component: AdminTaxUserListComponent },
              { path: 'add/d/:type/:empid', canActivate: [AuthGuardService], component: TaxDeclarationFormComponent },
              { path: 'add/e/:type/:empid', canActivate: [AuthGuardService], component: TaxInvestmentFormComponent },
              { path: 'detail/d/:id', canActivate: [AuthGuardService], component: TaxDeclarationDetailComponent },
              { path: 'detail/e/:id', canActivate: [AuthGuardService], component: TaxInvestmentDetailComponent },
            ]
          },
        ]
      },
      {
        path: 'employeeattendance',
        children: [
          { path: '', canActivate: [AuthGuardService], component: AttendanceEmpComponent },
        ]
      },
      {
        path: 'employeesearch',
        children: [
          { path: 'front', canActivate: [AuthGuardService], component: EmpSearchComponent },
          { path: 'back', canActivate: [AuthGuardService], component: EmpSearchComponent },
        ]
      },
      {
        path: 'attendancedevice',
        children: [
          {
            path: 'sitebranchmapping',
            children: [
              { path: '', canActivate: [AuthGuardService], component: SiteBranchMappingComponent },
              { path: 'add/:id', canActivate: [AuthGuardService], component: SiteBranchMappingFormComponent },
              { path: 'detail/:id', canActivate: [AuthGuardService], component: EmpSiteBranchMappingComponent },
            ]
          },
          {
            path: 'device', canActivate: [AuthGuardService],
            children: [
              { path: '', canActivate: [AuthGuardService], component: DeviceComponent },
              { path: 'deviceattendance/:sn', canActivate: [AuthGuardService], component: DeviceAttendanceComponent },
              { path: 'deviceemployeeattendance/:id/:sn', canActivate: [AuthGuardService], component: DeviceEmployeeAttendanceComponent },
              { path: 'deviceemployee/:sn', canActivate: [AuthGuardService], component: DeviceEmployeeComponent },
              { path: 'deviceconfiguration/:sn', canActivate: [AuthGuardService], component: DeviceConfigurationComponent },
            ]
          },
          // {
          //   path: 'empsitebranchmapping',
          //   children: [
          //     { path: '', canActivate: [AuthGuardService], component: EmpSiteBranchMappingComponent },
          //     //{ path: 'add/:id', canActivate: [AuthGuardService], component: EmpSiteBranchMappingFormComponent },
          //   ]
          // },
        ]
      },
      {
        path: 'musterattendance',
        children: [
          { path: '', canActivate: [AuthGuardService], component: MusterAttendanceComponent }
        ]
      },
      // { path: 'onlineuserrights', canActivate: [AuthGuardService], component: OnlineUserRightsComponent  },
      // {
      //   path: 'applicability',
      //   children: [
      //     { path: '', canActivate: [AuthGuardService], component: UserApplicabilityLoadComponent },
      //     { path: ':id', canActivate: [AuthGuardService], component: UserApplicabilityComponent }
      //   ]
      // },
      {
        path: 'request',
        children: [
          {
            path: 'adminregularization',
            children: [
              { path: '', canActivate: [AuthGuardService], component: AdminRegularizationComponent },
              { path: ':id', canActivate: [AuthGuardService], component: AdminRegularizationFormComponent }
            ]
          },
          {
            path: 'adminleave',
            children: [
              { path: '', canActivate: [AuthGuardService], component: AdminLeaveComponent },
              { path: ':id', canActivate: [AuthGuardService], component: AdminLeaveFormComponent }
            ]
          },
          {
            path: 'admincompoff',
            children: [
              { path: '', canActivate: [AuthGuardService], component: AdminCompOffComponent },
              { path: ':id', canActivate: [AuthGuardService], component: AdminCompOffFormComponent }
            ]
          },
          {
            path: 'admincompoffconsume',
            children: [
              { path: '', canActivate: [AuthGuardService], component: AdminCompOffConsumeComponent },
              { path: ':id', canActivate: [AuthGuardService], component: AdminCompOffConsumeFormComponent }
            ]
          },
        ]
      },
      {
        path: 'allocation',
        children: [
          {
            path: 'postingorder',
            children: [
              { path: '', canActivate: [AuthGuardService], component: PostingOrderViewComponent },
              { path: 'add/:id', canActivate: [AuthGuardService], component: PostingOrderFormComponent },
            ]
          },
          {
            path: 'transferorder',
            children: [
              { path: '', canActivate: [AuthGuardService], component: TransferOrderViewComponent },
              { path: 'add/:id', canActivate: [AuthGuardService], component: TransferOrderFormComponent },
            ]
          },
          {
            path: 'transferordertobranch',
            children: [
              { path: '', canActivate: [AuthGuardService], component: TransferOrderToBranchViewComponent },
              { path: 'add/:id', canActivate: [AuthGuardService], component: TransferOrderToBranchFormComponent },
            ]
          },
          {
            path: 'postingordersub',
            children: [
              { path: '', canActivate: [AuthGuardService], component: PostingOrderViewComponent },
              { path: 'add/:id', canActivate: [AuthGuardService], component: PostingOrderFormComponent },
            ]
          },
          {
            path: 'transferordersub',
            children: [
              { path: '', canActivate: [AuthGuardService], component: TransferOrderViewComponent },
              { path: 'add/:id', canActivate: [AuthGuardService], component: TransferOrderFormComponent },
            ]
          },
          {
            path: 'transferordertobranchsub',
            children: [
              { path: '', canActivate: [AuthGuardService], component: TransferOrderToBranchViewComponent },
              { path: 'add/:id', canActivate: [AuthGuardService], component: TransferOrderToBranchFormComponent },
            ]
          },
          { path: 'allotmentdelete', canActivate: [AuthGuardService], component: AllotmentDeleteComponent },
          { path: 'allotmenthistory', canActivate: [AuthGuardService], component: AllotmentHistoryReportComponent },
          {
            path: 'zinghr',
            children: [
              { path: '', canActivate: [AuthGuardService], component: ZingHRPostingOrderComponent },
              { path: 'add/:id', canActivate: [AuthGuardService], component: ZingHRPostingOrderAddComponent },
            ]
          },
        ]
      },
      {
        path: 'multisite',
        children: [
          { path: 'employee/:type', canActivate: [AuthGuardService], component: EmployeeMultisiteComponent },
          { path: 'subcontractor/:type', canActivate: [AuthGuardService], component: EmployeeMultisiteComponent },
        ]
      },
      {
        path: 'dailyattendance', canActivate: [AuthGuardService], component: DailyAttendance2Component
      },
      {
        path: 'excdays',
        children: [
          { path: '', canActivate: [AuthGuardService], component: ExceptionalDaysComponent },
          { path: 'add/:id', canActivate: [AuthGuardService], component: ExceptionalDaysFormComponent },
        ]
      },
      {
        path: 'ClientHelpDesk',
        children: [
          {
            path: 'TicketAssign',
            children: [
              { path: '', canActivate: [AuthGuardService], component: ClientAllTicketsComponent },
            ]
          },
          {
            path: 'Ticket',
            children: [
              { path: '', canActivate: [AuthGuardService], component: ClientAssignedTicketsComponent },
            ]
          },
          {
            path: 'helpdeskreport',
            children: [
              { path: '', canActivate: [AuthGuardService], component: ClientHelpdeskReportComponent }
            ]
          }
        ]
      },
      // {
      //   path: 'adminregularization',
      //   children: [
      //     { path: '', canActivate: [AuthGuardService], component: AdminRegularizationComponent },
      //     { path: ':id', canActivate: [AuthGuardService], component: AdminRegularizationFormComponent }
      //   ]
      // }
      // {
      //   path: 'user',
      //   children: [
      //     { path: '', canActivate: [AuthGuardService], component: UserMasterLoadComponent },
      //     { path: 'add/:id', canActivate: [AuthGuardService], component: UserMasterComponent },
      //     { path: 'applicability', canActivate: [AuthGuardService], component: UserApplicabilityComponent }
      //   ]
      // },
      {
        path: 'uploadmaster',
        children: [
          { path: '', canActivate: [AuthGuardService], component: UploadComponent, },
          { path: 'add', canActivate: [AuthGuardService], component: UploadFormComponent, },
        ]
      },
      {
        path: 'ratecontract',
        children: [
          { path: 'sbratecontract', canActivate: [AuthGuardService], component: SalaryBillingRatecontractComponent },
        ]
      },
      {
        path: 'attendancemanagement',
        children: [
          { path: '', canActivate: [AuthGuardService], component: AdminLeaveManagementComponent }
        ]
      },
      { path: 'resign', canActivate: [AuthGuardService], component: EmployeeResignComponent },
      { path: 'resignreason', canActivate: [AuthGuardService], component: ResignationReasonMasterComponent },
      {
        path: 'resignationapproval',
        children: [
          { path: '', canActivate: [AuthGuardService], component: ResignationapprovalComponent },
          { path: ':id', canActivate: [AuthGuardService], component: EmployeeTerminationFormComponent }
        ]
      },
      {
        path: 'manualtermination',
        children: [
          { path: '', canActivate: [AuthGuardService], component: EmployeeTerminationComponent },
          { path: ':id', canActivate: [AuthGuardService], component: EmployeeTerminationFormComponent }
        ]
      },
      { path: 'edashboard', canActivate: [AuthGuardService], component: EmployeeDashboardComponent},
      { path: 'edashboard2', canActivate: [AuthGuardService], component: EmployeeDashboard2Component},
    ]
  },
  //Pre On Boarding With Seperate Master Layout
  {
    path: 'preonboarding', canActivate: [AuthGuardService], component: PreOnboardinMainLayouComponent,
    children: [
      { path: 'add/:id/:draft', canActivate: [AuthGuardService], component: RegisterFormComponent },
      { path: 'detail/:id/:draft', canActivate: [AuthGuardService], component: RegisterDetailComponent },
    ]
  },
  {
    path: 'mailapproval', component: MailApprovalComponent,
  },
  {
    path: 'test', component: TestComponent,
  },
];
